<template>
	<mt-popup v-model="visible" position="bottom" class="my-time">
		<mt-picker
			:slots="myTimeSlots"
			@change="onChange"
			class="mint-datetime"
			ref="picker"
			show-toolbar>
			<span class="mint-datetime-action mint-datetime-cancel" @click="$emit('cancel')">{{ _ll('取消') }}</span>
			<span class="mint-datetime-action mint-datetime-confirm" @click="confirm">{{ _ll('确定') }}</span>
		</mt-picker>
	</mt-popup>
</template>

<script>
	import {Popup, Picker} from 'mint-ui'
    export default {
        name: "MyTimePicker",
		data () {
        	return {
				// visible: false,
				myTimeSlots: [{
					flex: 1,
					defaultIndex: 8,
					values: ['00','01','02','03','04','05','06','07','08','09','10','11',
							 '12','13','14','15','16','17','18','19','20','21','22','23'],
					className: 'slot-hour',
					textAlign: 'center'
				}, {
					divider: true,
					content: ':',
					className: 'slot2'
				}, {
					flex: 1,
					values: ['00','30'],
					className: 'slot-minute',
					textAlign: 'center'
				}],
				myHour: '',
				myMinute: ''
			}
		},
		props: {
			visible: {
				type: Boolean,
				default: false
			}
		},
		components: {
			'mt-popup': Popup,
			'mt-picker': Picker
		},
		methods: {
			onChange (picker, values) {
				let that = this
				if (values[0] !== that.myHour) {
					that.myHour = values[0]
				}
				if (values[1] != that.myMinute) {
					that.myMinute = values[1]
				}
			},
			confirm() {
				this.$emit('confirm', this.myHour+':'+this.myMinute);
			}
		}
    }
</script>

<style scoped>
	.my-time {
		width: 100%;
	}

</style>



// WEBPACK FOOTER //
// src/pages/payFee/my-time-picker.vue